/** App.js 공개 라우트와 동기 — 로그인 없이 열려야 하는 FE 경로 */

const PUBLIC_ROUTE_EXACT = new Set([
  '/landing/sgez',
  '/about',
  '/product',
  '/pricing',
  '/checkout',
  '/refund-policy',
  '/support',
  '/inquiry',
  '/b2b',
  '/terms',
  '/privacy',
  '/login',
  '/unauthorized',
  '/forbidden',
  '/bad-request',
  '/internal-server-error',
  '/bad-gateway',
  '/service-unavailable',
  '/gateway-timeout',
  '/signup',
  '/find-id',
  '/forgot-password',
  '/reset-password',
])

const PUBLIC_ROUTE_PREFIXES = [
  '/support/',
  '/auth/',
  '/p/',
  '/c/',
  '/share/',
  '/sign/',
  '/public/counsel-surveys/t/',
  '/claims/intake/',
  '/health-auth/',
]

const PUBLIC_ROUTE_PATTERNS = [
  /^\/orgs\/[^/]+\/landing\/?$/,
  /^\/@[^/]+\/?$/,
]

export function isPublicAppRoute(pathname) {
  if (!pathname || typeof pathname !== 'string') return false
  const normalized = pathname.replace(/\/+$/, '') || '/'
  if (PUBLIC_ROUTE_EXACT.has(normalized)) return true
  for (const prefix of PUBLIC_ROUTE_PREFIXES) {
    if (normalized === prefix.replace(/\/$/, '') || normalized.startsWith(prefix)) return true
  }
  for (const pattern of PUBLIC_ROUTE_PATTERNS) {
    if (pattern.test(normalized)) return true
  }
  return false
}
